const height = window.screen.height;
const width = window.screen.width;
const color = '#c59b6d';

export { height, width, color };
